<section class="filter-wrap-tile" data-cy="filter-wrap-tile">
  <ng-content></ng-content>
</section>
